import React from 'react'
import './style.scss'

const VerticalBanner = ({
  bannerlink,
  bannerimage,
  title,
  subtitle,
  id,
  text_color
}) => {
  return (<li
    className={"ais-Hits-item wineblock vertical-banner " + (text_color !== undefined ? text_color : '')}
    key={id}>
    <a className={'clickable'} href={bannerlink}>
      <div
        className={"background"}
        style={{backgroundImage: "url(/" + bannerimage + ")"}}>
        <div className="banner-content">
          <div className={'content-wrapper'}>
            <h2 className="title radiocanadabig25">{title}</h2>
            <div className={'subtitle'}>{subtitle}</div>
          </div>
        </div>
      </div>
    </a>
  </li>)
}
export default VerticalBanner



